import { configureStore } from "@reduxjs/toolkit";

import apiBooks from "api/books";
import apiCalcer from "api/calcer";
import apiCostSummary from "api/cost_summary";
import apiFsnb from "api/fsnb";
import apiKatsEstimate from "api/kats";
import apiLocalEstimate from "api/local_estimate";
import { apiNmck } from "api/nmck";
import apiOsrEditor from "api/object_estimate_editor";
import apiProjects from "api/projects";
import apiSandbox from "api/sandbox";
import apiSmetNorms from "api/smetnorm";
import apiSom from "api/som";
import apiSummaryEstimate from "api/summary_estimate";
import apiSsrEditor from "api/summary_estimate_editor";
import apiUserAdv from "api/user_adv";
import apiVor from "api/vor";
import apiVorEditor from "api/vor_editor";
import booksReducer from "slices/books/booksSlice";
import contextMenu from "slices/context_menu";
import { indexesGosrReducer } from "slices/indexesGosr/indexesGosrSlice";
import katsEditorSlice from "slices/kats_editor";
import localEstimateEditor from "slices/local_estimate_editor";
import { nmckReducer } from "slices/nmck/nmckSlice";
import { priceOfferReducer } from "slices/priceOffer/priceOfferSlice";
import resourceSheetReducers from "slices/resource_sheet";
import ribbon from "slices/ribbon";
import somSlice from "slices/som/somSlice";
import userAdvSlice from "slices/user_adv";
import windowDimensionsSlice from "slices/window_dimensions";

import advSearchSlice from "./slices/adv_search";
import authReducers from "./slices/auth";
import calcerSlice from "./slices/calcer";
import confirmReducers from "./slices/confirm";
import { costSummaryReducer } from "./slices/costSummary/costSummarySlice";
import { estimateViewerReducer } from "./slices/estimateViewer/estimateViewerSlice";
import fsnbSlice from "./slices/fsnb";
import globalVisibleSlice from "./slices/global_visible";
import importFilesSlice from "./slices/import_files";
import katsSlice from "./slices/kats";
import localEstimateSlice from "./slices/local_estimate";
import monitorSlice from "./slices/monitor";
import newsFeed from "./slices/news_feed";
import objectEstimateSlice from "./slices/object_estimate";
import { osrEditorReducer } from "./slices/osrEditor/osrEditorSlice";
import projectWorkSlice from "./slices/project_work";
import projectsReducers from "./slices/projects";
import protocolSlice from "./slices/protocol";
import { somDbReducer } from "./slices/somDb/somDbSlice";
import { ssrEditorReducer } from "./slices/ssrEditor/ssrEditorSlice";
import summaryEstimateSlice from "./slices/summary_estimate";
import { tutorialReducer } from "./slices/tutorial/tutorialSlice";
import { vorReducer } from "./slices/vor/vorSlice";
import { vorEditorReducer } from "./slices/vorEditor/vorEditorSlice";

const extraArgument = {
	apiBooks,
	apiCalcer,
	apiCostSummary,
	apiFsnb,
	apiKatsEstimate,
	apiLocalEstimate,
	apiNmck,
	apiOsrEditor,
	apiProjects,
	apiSandbox,
	apiSmetNorms,
	apiSom,
	apiSsrEditor,
	apiSummaryEstimate,
	apiUserAdv,
	apiVor,
	apiVorEditor,
};

export const setupStore = (preloadedState) =>
	configureStore({
		preloadedState,
		reducer: {
			auth: authReducers,
			projects: projectsReducers,
			resourceSheet: resourceSheetReducers,
			confirm: confirmReducers,
			projectWork: projectWorkSlice,
			localEstimate: localEstimateSlice,
			objectEstimate: objectEstimateSlice,
			summaryEstimate: summaryEstimateSlice,
			importFiles: importFilesSlice,
			kats: katsSlice,
			protocol: protocolSlice,
			calcer: calcerSlice,
			monitor: monitorSlice,
			advSearch: advSearchSlice,
			fsnb: fsnbSlice,
			globalVis: globalVisibleSlice,
			newsFeed: newsFeed,
			ribbon: ribbon,
			windowDimensions: windowDimensionsSlice,
			localEstimateEditor: localEstimateEditor,
			katsEditor: katsEditorSlice,
			contextMenu: contextMenu,
			userAdv: userAdvSlice,
			books: booksReducer,
			priceOffer: priceOfferReducer,
			som: somSlice,
			somDb: somDbReducer,
			vor: vorReducer,
			vorEditor: vorEditorReducer,
			osrEditor: osrEditorReducer,
			ssrEditor: ssrEditorReducer,
			costSummary: costSummaryReducer,
			nmck: nmckReducer,
			tutorial: tutorialReducer,
			indexesGosr: indexesGosrReducer,
			estimateViewer: estimateViewerReducer,
		},
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				thunk: {
					extraArgument,
				},
				serializableCheck: false,
			}), // https://redux-toolkit.js.org/api/getDefaultMiddleware
	});
